export const FETCH_WEBSITE_QUERY_QUEUE_LIST = "FETCH_WEBSITE_QUERY_QUEUE_LIST";
export const CREATE_WEBSITE_QUERY_QUEUE = "CREATE_WEBSITE_QUERY_QUEUE";
export const UPDATE_WEBSITE_QUERY_QUEUE = "UPDATE_WEBSITE_QUERY_QUEUE";
export const ASSIGN_TO_WEBSITE_QUERY_QUEUE = "ASSIGN_TO_WEBSITE_QUERY_QUEUE";
export const FETCH_TERMS = "FETCH_TERMS";
